document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.featured-collection__inner').forEach((section) => {
    const track = section.querySelector('[data-slider]');
    const leftBtn = section.querySelector('.featured-collection__nav-btn--left');
    const rightBtn = section.querySelector('.featured-collection__nav-btn--right');

    if (!track || !leftBtn || !rightBtn) return;

    const scrollAmount = 200;

    function updateButtonVisibility() {
      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;

      if (scrollLeft <= 0) {
        leftBtn.classList.add('is-hidden');
      } else {
        leftBtn.classList.remove('is-hidden');
      }

      if (scrollLeft >= maxScroll - 1) {
        rightBtn.classList.add('is-hidden');
      } else {
        rightBtn.classList.remove('is-hidden');
      }
    }

    updateButtonVisibility();

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateButtonVisibility);
    });

    leftBtn.addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
});
